import { render } from "./AppMenu.vue?vue&type=template&id=ce372b96&scoped=true"
import script from "./AppMenu.vue?vue&type=script&setup=true&lang=js"
export * from "./AppMenu.vue?vue&type=script&setup=true&lang=js"

import "./AppMenu.vue?vue&type=style&index=0&id=ce372b96&lang=scss&scoped=true"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-ce372b96"],['__file',"src/components/Ui/AppMenu.vue"]])
/* hot reload */
if (module.hot) {
  __exports__.__hmrId = "ce372b96"
  const api = __VUE_HMR_RUNTIME__
  module.hot.accept()
  if (!api.createRecord('ce372b96', __exports__)) {
    api.reload('ce372b96', __exports__)
  }
  
  module.hot.accept("./AppMenu.vue?vue&type=template&id=ce372b96&scoped=true", () => {
    api.rerender('ce372b96', render)
  })

}


export default __exports__